import React from 'react'


const Preloader = ()=>{
    return <React.Fragment>        
<div className="theme-loader">
    <div className="ball-scale">
        <div className='contain'>
            <div className="ring">
                <div className="frame"></div>
            </div>
        </div>
    </div>
</div>
    </React.Fragment>
}
export default React.memo(Preloader)